export default "__VITE_ASSET__B9MykIW2__$_?format=webp__"